// extracted by mini-css-extract-plugin
export default {"user_picture":"style_user_picture__60PcS","oneRow":"style_oneRow__toMrw","userSummary":"style_userSummary__gSap5"};